import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import ChartHeader from '@/business-components/chart-header';
import Footer from '@/business-components/footer';
import IndustryInfo from '@/business-components/IndustryInfo';
// import BrandInfo from '@/business-components/BrandInfo';
import PopularInvestor from '@/business-components/PopularInvestor';
import ReportGallery from '@/business-components/ReportGallery';
import Layout from '@/layouts';
import { getIndustryResearchReportList } from '@/services/report';
import { ConHomeWebController } from '@/services/swagger/ConHomeWebController';
import type {
  CityFinanceRoundsData,
  ConHomeBrandRankingVo,
  ConHomeBrandSubscribe,
  ConHomeIndustryFloatVo,
  ConHomeIndustryHeader,
  ConHomeNewBrandResponse,
  ConHotFinance,
  HotCity,
} from '@/services/swagger/data-contracts';
import ServerSideFetch from '@/utils/server-side-fetch';
import Recorded from './components/Recorded';
// import NewBrand from './components/NewBrand';
// import TotalNum from './components/TotalNum';
import styles from './index.module.scss';

const controller = new ConHomeWebController();

export type IndexPageServiderProps = {
  /** 行业标签列表 */
  industryLabelList: ConHomeIndustryHeader[];
  /** 热门行业品牌增长力变化总览 */
  industryFloatList: ConHomeIndustryFloatVo[];
  /** 排名涨幅TOP5品牌 */
  brandRankingList: ConHomeBrandRankingVo[];
  /** 订阅Top5品牌 */
  brandSubscriptionList: ConHomeBrandSubscribe[];
  /** 品牌信息数据统计月份 */
  brandDate: string;
  /** 投融资列表 */
  investorList: ConHotFinance[];
  /** 投融资信息数据统计月份 */
  investmentDate: string;
  /** 热门城市 */
  cityList: HotCity[];
  /** 热门城市品牌融资分布 */
  cityFinanceRoundsList: CityFinanceRoundsData[];
  /** 热门城市品牌融资分布统计月份 */
  cityFinanceDate: string;
  reportList: any;
  newBrand: ConHomeNewBrandResponse;
  cityData: any;
};
export const getServerSideProps: GetServerSideProps<IndexPageServiderProps> = async ({ res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=15, stale-while-revalidate=59');
  const industry = await ServerSideFetch(controller.conHomeWebControllerV1HomeIndustryHeaderListUsingGet1);
  const brand = await ServerSideFetch(controller.conHomeWebControllerV1HomeBrandInfoUsingGet1);
  const investor = await ServerSideFetch(controller.conHomeWebControllerV1HomeHotFinanceUsingGet1);
  const city = await ServerSideFetch(controller.conHomeWebControllerV1HomeHotCityDataUsingGet1);
  const newBrand = await ServerSideFetch(controller.conHomeWebControllerV1HomeNewBrandDataUsingGet1);
  const report = await getIndustryResearchReportList();
  const cityData = await ServerSideFetch(controller.conHomeWebControllerV1HomeNewBrandCityDataUsingGet1);
  return {
    props: {
      newBrand: newBrand?.data || {},
      cityData: cityData?.data?.cityData || [],
      industryLabelList: industry?.data?.list || [],
      industryFloatList: brand?.data?.conHomeIndustryFloatVoList || [],
      brandSubscriptionList: brand?.data?.conHomeBrandSubscribeList || [],
      brandRankingList: brand?.data?.conHomeBrandRankingVoList || [],
      brandDate: brand?.data?.updateTimeStr || '',
      investorList: investor?.data?.conHotFinanceList || [],
      investmentDate: investor?.data?.updateTimeStr || '',
      cityList: city?.data?.hotCity || [],
      cityFinanceRoundsList: city?.data?.cityFinanceRoundsData || [],
      cityFinanceDate: city?.data?.updateTimeStr,
      reportList: report?.data?.reportInformationList || [],
    },
  };
};

function IndexPage({
  industryLabelList,
  // industryFloatList,
  // brandSubscriptionList,
  // brandRankingList,
  // brandDate,
  investorList,
  investmentDate,
  cityList,
  cityFinanceRoundsList,
  cityFinanceDate,
  reportList,
  newBrand,
  cityData,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  console.log(cityData);
  return (
    <>
      <Layout
        title="CBNData品牌数集——中国新消费品牌数据库"
        description="CBNData品牌数集是第一财经商业数据中心（CBNData）旗下一款衡量品牌综合实力的可视化数据工具，基于CBNData沉淀的中国新消费品牌增长力评估模型与数据能力，从品牌赛道潜力、组织能力、经营能力、产品竞争力、营销能力、供应链能力、用户发展能力等7个维度，系统化帮助投资人及品牌创始人衡量品牌综合实力、评估品牌风险、分析行业竞争格局以及挖掘高增长潜力的新锐品牌。"
        keyword="消费、新消费、中国新消费、品牌、数据、数据库、国货、国潮、增长、风险评估、行业、赛道、竞品、组织、公司、产品、营销、供应链、用户、数据工具、数据可视化，品牌数集、CBNData、CBN、第一财经"
        isShowNavBar
        isFrapMain
        FooterComponent={Footer}
      >
        <div className={styles.content}>
          <div className={styles.leftContent}>
            <IndustryInfo industryLabelList={industryLabelList} />
            {/*<BrandInfo*/}
            {/*  brandSubscriptionList={brandSubscriptionList}*/}
            {/*  brandRankingList={brandRankingList}*/}
            {/*  industryFloatList={industryFloatList}*/}
            {/*  brandDate={brandDate}*/}
            {/*/>*/}
            <PopularInvestor
              investorList={investorList}
              cityList={cityList}
              cityFinanceRoundsList={cityFinanceRoundsList}
              investmentDate={investmentDate}
              cityFinanceDate={cityFinanceDate}
            />
            <ReportGallery reportList={reportList} />
          </div>
          <div className={styles.rightContent}>
            <ChartHeader
              title="品牌库信息"
              titleFontSize={20}
              dateSubTitle={true}
              extra={
                <a target="_blank" href="/consume-brand/brand">
                  {'查看更多 >>'}
                </a>
              }
              date={newBrand?.updateTimeStr}
            ></ChartHeader>
            {/*<TotalNum data={newBrand?.overviewData} />*/}
            {/*<NewBrand data={newBrand?.newBrandIndustryData || []} homeNewBrandDesc={newBrand?.homeNewBrandDesc} />*/}
            <Recorded
              brandIndustryData={newBrand?.brandIndustryData || []}
              financeData={newBrand?.financeData || []}
              cityData={cityData || []}
            />
          </div>
        </div>
      </Layout>
      {/* <Footer /> */}
      <ReactTooltip id="tags" arrowColor="transparent" className={styles.tagsToolTip} />
    </>
  );
}

export default IndexPage;
